import { ServiceOrderType } from "../_constants/serviceOrder.ts";
import Axios from "../_helpers/axiosHelper.ts";
import { Agency } from "../common/interfaces.ts";

export const getDateByType = (service: any) => {
  let date = ".";
  switch (service.type) {
    case ServiceOrderType.DIAGNOSTIC:
    case ServiceOrderType.INCOMING_INVENTORY:
    case ServiceOrderType.RENTAL_VISIT:
    case ServiceOrderType.ERP_EXPRESS:
    case ServiceOrderType.PRE_VISIT_ADVICE:
    case ServiceOrderType.VIRTUAL_VISIT:
      date = service.appointment.person.rentalStartDate;
      break;
    case ServiceOrderType.OUTGOING_INVENTORY:
      date = service.appointment.person.rentalEndDate;
      break;
  }

  return date;
};

export const listAgency = (rightValue: string): Promise<Agency[]> =>
  Axios.get(`/agencies/rights/${rightValue}`);

